import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { StringUtils } from '@shared/helpers/StringUtils';
import { cnpj, cpf } from 'cpf-cnpj-validator';

@Directive({
  selector:
    // tslint:disable-next-line:directive-selector
    '[validateCpfCnpj][formControlName],[validateCpfCnpj][formControl],[validateCpfCnpj][ngModel]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CpfCnpjValidator),
      multi: true,
    },
  ],
})

export class CpfCnpjValidator implements Validator {
  validate(control: AbstractControl): ValidationErrors {
    const value = control.value;

    if (value) {
      const onlyNumbers = StringUtils.onlyNumbers(value);

      if (onlyNumbers.length === 11) {
        const valid = cpf.isValid(onlyNumbers);

        if (valid) {
          return null;
        }
        return { validateCpf: true };
      }

      if (onlyNumbers.length === 14) {
        const valid = cnpj.isValid(onlyNumbers);

        if (valid) {
          return null;
        }
        return { validateCnpj: true };
      }
    }

    return null;
  }
}
